export default __webpack_public_path__ + "static/media/find-level-icon.de796da1.svg";